<app-carousel 
[images]="images"              
[indicators]="true"              
[autoSlide]="true"  
[prevNextButtons]="true"              
[interval]="5000"
>
</app-carousel>